import { Injectable, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    AddressAutocompleteServiceProxy, DistrictDto,
    DistrictServiceProxy,
    KeyValuePairOfStringString
} from '@shared/service-proxies/service-proxies';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { tap } from 'rxjs';
import { $ } from '@node_modules/protractor';
import { AppConsts } from '@shared/AppConsts';
import { CustomValidationService } from '../common/validation/custom-validation.service';

@Injectable()
export class AddressAutoCompleteService extends AppComponentBase{

    postCode: string = null;
    cities: KeyValuePairOfStringString[] = [];
    citySuggestions: string[] = [];
    streets: KeyValuePairOfStringString[] = [];
    streetSuggestions: string[] = [];
    houseNumbers: KeyValuePairOfStringString[] = [];
    houseNumberSuggestions: string[] = [];
    mainFormReference: FormGroup;

    plzDistricts: DistrictDto[];

    constructor(
        private addressAutocompleteServiceProxy: AddressAutocompleteServiceProxy,
        private validationService: CustomValidationService,
        private districtService: DistrictServiceProxy,
        injector: Injector
    ) {
        super(injector);

        districtService.getAllDistricts().subscribe(list => {
            this.plzDistricts = list;
        });
    }

    searchCities(postCode: string) {
        if (postCode && postCode.length === 4) {
            this.addressAutocompleteServiceProxy.getCitiesByPostCode(postCode).subscribe(cities => {
                this.citySuggestions = cities.map((city: KeyValuePairOfStringString) => city.value);
                this.cities = cities;
                this.postCode = postCode;
            });
        } else {
            this.citySuggestions = [];
        }
    }

    onCitySelected(city: string) {
        this.mainFormReference.get('postCode').setValue(this.postCode);
        this.mainFormReference.get('city').setValue(city);
        this.postCode = null;
        this.citySuggestions = [];
        this.trySetDistrict();
    }

    trySetDistrict() {
        if (this.mainFormReference.get('district')) {
            const code = this.mainFormReference.get('postCode').value;
            const district = this.plzDistricts.find(d =>
                d.plz?.some(plzItem => plzItem.plz === Number(code))
            );

            if (district) {
                this.mainFormReference.get('district').setValue(this.l(district.districtCodeId));
            } else {
                this.mainFormReference.get('district').setValue(null);
            }
        }
    }

    onCitySelectedForIndex(city: string, index: number, groupName: string) {
        const previousEmployments = this.mainFormReference.get(groupName) as FormArray;
        const previousemployment = previousEmployments.at(index) as FormGroup;
        previousemployment.get('postCode').setValue(this.postCode);
        previousemployment.get('city').setValue(city);
        this.postCode = null;
        this.citySuggestions = [];
    }

    searchStreets(query: string, index: number = undefined, groupName: string = undefined) {
        let city = '';
        if (index != undefined) {
            const previousEmployments = this.mainFormReference.get(groupName) as FormArray;
            const previousemployment = previousEmployments.at(index) as FormGroup;
            city = previousemployment.get('city').value;
        } else {
            city = this.mainFormReference.get('city').value;
        }

        let cityId = Number(this.cities.find(c => c.value === city)?.key);
        if (isNaN(cityId)) {
            this.streets = [];
            this.streetSuggestions = [];
            return;
        }

        this.addressAutocompleteServiceProxy.getStreetsByCity(cityId, query).subscribe((streets: KeyValuePairOfStringString[]) => {
            this.streets = streets;
            this.streetSuggestions = streets.map(x => x.value);
        });
    }

    onStreetSelected(selection: string) {

    }

    searchHouseNumbers(query: string, index: number = undefined, groupName: string = undefined) {
        let street = '';
        if (index != undefined) {
            const previousEmployments = this.mainFormReference.get(groupName) as FormArray;
            const previousemployment = previousEmployments.at(index) as FormGroup;
            street = previousemployment.get('street').value;
        } else {
            street = this.mainFormReference.get('street').value;
        }

        let streetId = Number(this.streets.find(str => str.value === street)?.key);
        if (isNaN(streetId)) {
            this.houseNumbers = [];
            this.houseNumberSuggestions = [];
            return;
        }

        this.addressAutocompleteServiceProxy.getHouseNumbersByStreetId(streetId, query).subscribe((houseNumbers: KeyValuePairOfStringString[]) => {
            this.houseNumbers = houseNumbers;
            this.houseNumberSuggestions = houseNumbers.map(x => x.value);
        });
    }
    updatePostCodeValidators(index: number = undefined, isPostCodeRequired: boolean = true, groupName: string = undefined, formArrayIndex: number = 0): void {
        let postCodeControl: AbstractControl;

        if (index != undefined && groupName != undefined) {
            const previousEmployments = this.mainFormReference.get(groupName) as FormArray;
            const previousemployment = previousEmployments.at(index) as FormGroup;
            postCodeControl = previousemployment.get('postCode');
        } else {
            postCodeControl = this.mainFormReference.get('postCode');
        }

        postCodeControl.setValidators(this.validationService.getPostCodeValidators(!isPostCodeRequired, this.isCountrySwitzerland(index, groupName, formArrayIndex)));
        postCodeControl.updateValueAndValidity();
    }

    isCountrySwitzerland(index: number = 0, groupName: string = undefined, formArrayIndex: number = 0): boolean {

        let countryControl: AbstractControl;
        if (groupName !== undefined) {
            const previousEmployments = this.mainFormReference.get(groupName) as FormArray;
            const previousemployment = previousEmployments.at(formArrayIndex) as FormGroup;
            countryControl = previousemployment.get('countryId');
        } else {
            countryControl = this.mainFormReference.get('countryId');
        }

        let isCountryCh = true;
        if (countryControl != null) { // The country field is not required
            isCountryCh = countryControl.value === AppConsts.codes.country.ch;
        }

        return isCountryCh;
    }

    onHouseNumberSelected(selection: KeyValuePairOfStringString) {

    }
}
